module.exports = __webpack_public_path__ + "assets/character2_cheerup.79b8e007.svg";